<template><div v-if="show_options"><tile-question-layout :options_loaded="options_loaded" :passed_filter="passed_filter" :title="title" :loading="loading" v-model:target="localTarget" :filtered_option_list="filtered_option_list" :thumb_url="thumbURL" :component_id="component_id" :fabricator="fabricator" :extra_text="extra_text">

</tile-question-layout></div></template>

<script type="text/ecmascript-6">
    import TileQuestion from "./mixin/TileQuestion.vue";

    export default {
        mixins: [
            TileQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Select your decorative handle';
                }
            },
            component_id: {
                default(){
                    return 'hardware_decorative_handle';
                }
            },
            slab: {
                required: true
            },
            hardwareColour: {
                required: true
            },
            doorRange: {
                required: true
            },
            extra_text: {
              default() {
                return '';
              }
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.slab, this.hardwareColour, this.doorRange);
            },
            thumbURL(){
                return '/thumb/hardware/';
            },
            url(){
                return '/api/options/' + this.fabricator + '/hardware-decorative-handle?slab=' + this.slab + '&hardware_colour=' + this.hardwareColour + '&door_range=' + this.doorRange;
            },
            cache_key(){
                return '_' + this.slab + '_' + this.hardwareColour + '_' + this.doorRange;
            },
            show_options(){
                return this.filtered_option_list.length > 0;
            }
        },
        watch: {
            'slab': function (val, oldVal) {
                this.update_options();
            },
            'hardwareColour': function (val, oldVal) {
                this.update_options();
            },
            'doorRange': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
